var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('router-view'),(this.$store.state.loading.blockUI > 0)?_c('BlockUI',[_c('semipolar-spinner',{attrs:{"animation-duration":2000,"size":100,"color":_vm.$themes.success}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }